import {Component,Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'etat-operation',
    templateUrl: './etat-operation.component.html',
    styleUrls: ['./etat-operation.component.scss']
})
export class EtatOperationComponent {
    /** Code de l'état opération */
    @Input() etatOperationCode ?: string ;

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService) {
    }

    //Définition des libellés
    get libelle(): string {
        //Définition des couleurs
        switch (this.etatOperationCode) {
            case "NON_JUSTIFIE":
                return this.translateService.instant("opeCarte.liste.etatsCarte.nonJustifie");
                break;
            case "DEPENSES_PERSONNELLES":
                return this.translateService.instant("opeCarte.liste.etatsCarte.depensesPersonnelles");
                break;
            case "ARCHIVES":
                return this.translateService.instant("opeCarte.liste.etatsCarte.archives");
                break;
            case "EN_ATTENTE":
                return this.translateService.instant("opeCarte.liste.etatsCarte.enAttente");
                break;
            case "PARTIELLEMENT_JUSTIFIE":
                return this.translateService.instant("opeCarte.liste.etatsCarte.partiellementJustifie");
                break;
            case "JUSTIFIE":
                return this.translateService.instant("opeCarte.liste.etatsCarte.justifie");
                break;
            default:
                return this.translateService.instant("opeCarte.liste.etatsCarte.nonJustifie");
        }
    }

    //Définition des couleurs
    get colors(): String[] {
        //Définition des couleurs
        switch (this.etatOperationCode) {
            case "NON_JUSTIFIE":
                return ["grey","grey","grey"];
                break;
            case "DEPENSES_PERSONNELLES":
                return ["green","grey","grey"];
                break;
            case "ARCHIVES":
                return ["green","green","green"];
                break;
            case "EN_ATTENTE":
                return ["orange","grey","grey"];
                break;
            case "PARTIELLEMENT_JUSTIFIE":
                return ["orange","orange","grey"];
                break;
            case "JUSTIFIE":
                return ["green","green","grey"];
                break;
            default:
                return ["grey","grey","grey"];
        }
    }
}